// Unified service for employee contract operations
import { employeeContractListService } from './services';
import { employeeContractEditService } from './services/employeeContractEdit.service';
import { employeeContractActiveService } from './services/employeeContractActive.service';
import { employeeContractDeleteService } from './services/employeeContractDelete.service';


export class EmployeeContractService {
  // List operations
  list = employeeContractListService.list.bind(employeeContractListService);

  // Edit operations
  get = employeeContractEditService.get.bind(employeeContractEditService);
  update = employeeContractEditService.update.bind(employeeContractEditService);

  // Active contract operations: dedicated endpoints, authorized by the
  // "Condiciones laborales" section instead of the Contracts interface
  getActive = employeeContractActiveService.getActive.bind(employeeContractActiveService);
  updateActive = employeeContractActiveService.updateActive.bind(employeeContractActiveService);

  // Delete operations
  delete = employeeContractDeleteService.delete.bind(employeeContractDeleteService);
}

export const employeeContractService = new EmployeeContractService();
